$(window).scroll(function(e){
    var $searchMobile = $("#serv-search");
    if ($searchMobile.hasClass("services-search-interna")) {
        if ($(window).scrollTop() > 195){
            $searchMobile.addClass("search-fixed");
        }
        else {
            $searchMobile.removeClass("search-fixed");
        }
    }
    else {
        if ($(window).scrollTop() > 350){
            $searchMobile.addClass("search-fixed");
        }
        else {
            $searchMobile.removeClass("search-fixed");
        }
    }
});
$(window).load(function () {
    $('.hero-services-banner-default').addClass('display-none');
    $('.wrapper-menu').css('display','block');
    $('.hero-services-banner').css('display', 'block');
    $('.hero-services-container-interna').removeClass('display-none');
});

$(document).ready(function() {
    $('.hero-services-banner').css('display', 'none');
    $('.hero-services-banner-default').removeClass('display-none');
    
    var urlHome = 'http://www.sodimac.com.pe/sodimac-pe/content/a1700001/servicios',
        urlReturnHome = 'http://www.sodimac.com.pe/sodimac-pe/content/a1700001/servicios?cid=lnd21532';

    if (window.location.href === urlHome || window.location.href === urlReturnHome) {
        $('#main.newMainSection .container .col-md-12').addClass('no-top');
    }
    
    jQuery('.container img.img-svg').each(function() {
        var $img = jQuery(this);
        var imgID = $img.attr('id');
        var imgClass = $img.attr('class');
        var imgURL = $img.attr('src');

        jQuery.get(imgURL, function(data) {
            var $svg = jQuery(data).find('svg');

            if (typeof imgID !== 'undefined') {
                $svg = $svg.attr('id', imgID);
            }
            if (typeof imgClass !== 'undefined') {
                $svg = $svg.attr('class', imgClass + ' replaced-svg');
            }

            $svg = $svg.removeAttr('xmlns:a');

            if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
                $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
            }

            $img.replaceWith($svg);

        }, 'xml');
    });
    $(document).on('click', '.button-loading-services', function() {
        var $buttonDisplay = $( ".button-display" );
        var $menuCategory = $('.menu-category');
        if($buttonDisplay.hasClass( "display-none" )){
            $buttonDisplay.removeClass('display-none');
            $('.row.menu-category-container').slideUp(500,"linear");
            $('.menu-category').each(function (index, element) {
                $(this).find('.img-arrow').attr('src', '/static/categorias/contenidoEstatico/landings/landing_servicios/assets/img/flecha_abajo.png');
                $(this).find('.pos-bottom-left').removeClass('bg-blue-active');
                $(this).removeClass('opacity-category');
            });
            $('.button-loading-services').text("CARGAR MENOS SERVICIOS");
        }
        else {
            $buttonDisplay.addClass('display-none');
            $('.row.menu-category-container').slideUp(500,"linear");
            $('.menu-category').each(function (index, element) {
                $(this).find('.img-arrow').attr('src', '/static/categorias/contenidoEstatico/landings/landing_servicios/assets/img/flecha_abajo.png');
                $(this).find('.pos-bottom-left').removeClass('bg-blue-active');
                $(this).removeClass('opacity-category');
            });
            $('.button-loading-services').text("CARGAR MÁS SERVICIOS");
        }
    });
    $(document).on('click', '.menu-category', function() {
        var $this = $(this),
            $menuCategory = $('.menu-category'),
            categoryName = $this.data('category');
        
        if($this.find('.img-arrow').attr('src') === '/static/categorias/contenidoEstatico/landings/landing_servicios/assets/img/flecha_abajo.png') {
            $('.menu-category-container').removeClass('opacity-category');
            $('.menu-category-container').slideUp(500,"linear");
            $('#container-slider-menu .menu-category-container').slideUp(500,"linear");
            $menuCategory.each(function (index, element) {
                $(this).find('.img-arrow').attr('src', '/static/categorias/contenidoEstatico/landings/landing_servicios/assets/img/flecha_abajo.png');
                $(this).find('.pos-bottom-left').removeClass('bg-blue-active');
                $(this).addClass('opacity-category');
            });
            $('#container-slider-menu').empty();
            $('.slider-menu').find('*').removeClass('bg-blue-active');
            $this.find('.img-arrow').attr('src', '/static/categorias/contenidoEstatico/landings/landing_servicios/assets/img/flecha_arriba.png');
            $this.find('.pos-bottom-left').addClass('bg-blue-active');
            $('.menu-'+ categoryName +'-container').slideDown(500,"linear");
            $this.removeClass('opacity-category');
            $('.menu-' + categoryName + '-container').parent().find('*').removeClass('border-bottom-category');
            $('.menu-' + categoryName + '-container').addClass('border-top-services');

        } else {
            $this.find('.img-arrow').attr('src', '/static/categorias/contenidoEstatico/landings/landing_servicios/assets/img/flecha_abajo.png');
            $this.find('.pos-bottom-left').removeClass('bg-blue-active');
            $('.menu-'+ categoryName +'-container').slideUp(500,"linear");
            $menuCategory.removeClass('opacity-category');
            $('.menu-' + categoryName + '-container').removeClass('border-top-services');
        }
    });

    $(document).on('click', '.menu-cat', function() {

            var $this = $(this),
                categoryName = $this.data('slider'),
                $containerMenuSlider = $('#container-slider-menu'),
                $menuCategoryContainer = $('.menu-category-container'),
                $menuCategory = $('.menu-category');
            
            $menuCategoryContainer.slideUp(500,"linear");
            $this.toggleClass('bg-blue-active');
            
            if($this.hasClass('bg-blue-active')) {
                $('.menu-cat').not($this).removeClass('bg-blue-active');
                $containerMenuSlider.empty();
                $this.addClass('bg-blue-active');
                $menuCategory.each(function (index, element) {
                    $(this).find('.img-arrow').attr('src', '/static/categorias/contenidoEstatico/landings/landing_servicios/assets/img/flecha_abajo.png');
                    $(this).find('.pos-bottom-left').removeClass('bg-blue-active');
                    $(this).removeClass('opacity-category');
                });

                $('.menu-category-container.menu-' + categoryName + '-container').clone()
                    .removeClass('border-top-services')
                    .addClass('margin-bottom-menu')
                    .appendTo($containerMenuSlider)
                    .slideDown(500,"linear");
            } else {
                $menuCategory.each(function (index, element) {
                    $(this).find('.img-arrow').attr('src', '/static/categorias/contenidoEstatico/landings/landing_servicios/assets/img/flecha_abajo.png');
                    $(this).find('.pos-bottom-left').removeClass('bg-blue-active');
                    $(this).removeClass('opacity-category');
                });

                $('.menu-category-container.menu-' + categoryName + '-container').slideUp(500,"linear");
                $this.removeClass('bg-blue-active');
            }
    });


    $(document).on('click', '.category-mobile', function() {

        if ($(window).width() < 992) {
            var $this = $(this),
                $menuMobile = $('.category-mobile'),
                categoryNameMobile = $this.data('categorymob');

            if ($this.find('.img-arrow-mob').attr('src') === '/static/categorias/contenidoEstatico/landings/landing_servicios/assets/img/flecha_abajo-mob.png') {
                $menuMobile.each(function (index, element) {
                    $(this).find('.img-arrow-mob').attr('src', '/static/categorias/contenidoEstatico/landings/landing_servicios/assets/img/flecha_abajo-mob.png')
                    $('.menu-mob').slideUp(500,"linear");

                });
                $this.find('.img-arrow-mob').attr('src', '/static/categorias/contenidoEstatico/landings/landing_servicios/assets/img/flecha_arriba-mob.png');
                $('.menu-mob-' + categoryNameMobile).slideDown(500,"linear");
            } else {
                $this.find('.img-arrow-mob').attr('src', '/static/categorias/contenidoEstatico/landings/landing_servicios/assets/img/flecha_abajo-mob.png');
                $('.menu-mob-' + categoryNameMobile+' .menu-mobile-container');
                $('.menu-mob-' + categoryNameMobile).slideUp(500,"linear");

            }
        }
    });

    $(document).on('click', '.button-loading-services-mobile', function() {
        var $buttonDisplayMob = $( ".button-display-mobile" );
        if($buttonDisplayMob.hasClass( "display-none")){
            $buttonDisplayMob.removeClass('display-none');
            $('.menu-mob').slideUp(500,"linear");
            $('.category-mobile').find('.img-arrow-mob').attr('src', '/static/categorias/contenidoEstatico/landings/landing_servicios/assets/img/flecha_abajo-mob.png');
            $('.button-loading-services-mobile').text("CARGAR MENOS SERVICIOS");
        }
        else {
            $buttonDisplayMob.addClass('display-none');
            $('.menu-mob').slideUp(500,"linear");
            $('.category-mobile').find('.img-arrow-mob').attr('src', '/static/categorias/contenidoEstatico/landings/landing_servicios/assets/img/flecha_abajo-mob.png');
            $('.button-loading-services-mobile').text("CARGAR MÁS SERVICIOS");
        }
    });

    $('.modal-article .modal-mobile-search .btn-close-mobile').on('click',function(){
        $('.modal').modal('hide');
    });

    $(document).on('click', '.text-nuestro-servicio', function() {
        $('.modal-category').modal('hide');
        $("body").addClass("modal-open");
    })

    $("#myModalSearchService").on("show", function () {
        $("body").addClass("modal-open");
    }).on("hidden", function () {
        $("body").removeClass("modal-open");
    });

});